import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const LISTADO_TIPOS = 'LISTADO_TIPOS';
const GUARDAR_TIPO = 'GUARDAR_TIPO';
const PAGE = 'PAGE';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setPage = page => ({
    type: PAGE,
    page,
});

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = (page = 1) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { page, id };
    api.get('/tipo_abono_facturacion', params).then((response)=>{
        dispatch({ type: LISTADO_TIPOS, data: response });
        dispatch(setPage(page));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar tipos de abono',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroTipo = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormTipoAbonoFac.values;
    const formData = {
        tipo: data.tipo,
        descripcion: data.descripcion,
        tipo_documento: 'ABONO',
        categoria: data.categoria,
        libro: data.libro,
        modulo: 'FAC',
        empresa: id_emp[5]
    }
    dispatch(setLoader(true));
    api.post('/tipo_abono_facturacion/', formData).then(() => {
        NotificationManager.success(
            'Tipo abono creado',
            'Exito',
            3000
        );
        let ruta = `/facturacion/${id_emp[5]}/tipo_abono`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarTipo = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormTipoAbonoFac.values;
    const id = datos.id;
    const formData = {
        id: id,
        tipo: datos.tipo,
        descripcion: datos.descripcion,
        tipo_documento: 'ABONO',
        modulo: 'FAC',
        empresa: id_emp[5]
    }
    dispatch(setLoader(true));
    api.put(`/tipo_abono_facturacion/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Tipo abono modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/facturacion/${id_emp[5]}/tipo_abono`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al modificar tipo de abono',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/tipo_abono_facturacion/${id}`).then((response) => {
        dispatch({type: GUARDAR_TIPO, lectura: response });
        dispatch(initializeForm('FormTipoAbonoFac', response ));
    }).catch((error)=>{
        console.log("error: ", error)
        NotificationManager.error(
            'Ocurrió un error al consultar tipo de abono',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroTipo,
    modificarTipo,
    getModulo,
    leer
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_TIPOS]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [GUARDAR_TIPO]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    lectura: [],
    modulo: [],
    data: {
        results: [],
        count: 0,
    },
    page: 1,
};

export default handleActions(reducers, initialState)